<template>
	<div class="room" v-loading="!reloadFlag">
		<section class="room__header"></section>
		<section v-if="reloadFlag" class="room__body" ref="roombody" id="roombody">
      <agora-player
        v-if="liveStatus === 2 && agoraClient"
        :playAgoraState="playAgoraState"
        :streamInstance="streamInstance"
        @play.once="playHandle" />
      <ss-vue-player 
        v-else-if="playUrl" 
        class="room__player" 
        :playUrl="playUrl"
        :playUrlStreamInfo="playUrlStreamInfo"
        :coverImg="coverImg"
        :isLive="isLive"
        :liveStatus="liveStatus"
        @play.once="playHandle" />
      <!-- zindex 10 -->
      <div 
        class="room__touch_holder"
        @touchstart.stop="touchstartHandle"
        @touchend.stop="touchendHandle">
      </div>
      <div class="room__top_bg">
			<room-left-top-box :leftTopInfo="leftTopInfo" class="room__left_top"></room-left-top-box>
      <room-right-top-box class="room__right_top"></room-right-top-box>
      </div>
      <div v-if="liveStatus === 1" class="room__preview">
        <div class="room__preview_left">
          <div class="room__preview_livename">{{this.shareInfo.liveName}}</div>
          <p>{{previewInfo}}</p>
        </div>
        <div class="room__preview_right global_pointer" @click="rsvp" v-if="!addRemind">
          <span>RSVP</span>
        </div>
        <div class="room__preview_right previewed" v-else>
          <span>RSVP’d</span>
        </div>
      </div>
      <div class="room__comment_backgroud"></div>
			<comment 
        :class="['room__comment', {'room__comment-replay' : liveStatus === 4}]"
        ref="comment" 
        :commentMsgList="commentMsgList"></comment>
        <!-- 表情往这写 -->
        <quick-phrases 
        :class="['room__quick_phrases', {'room__quick_phrases-replay' : liveStatus === 4}]"
        :data="quickPhrasesData"
        @sendText="sendText"></quick-phrases>
			<room-bottom-box 
        ref="tools" 
        :goodLength="goodsLength" 
        :cert="certificationInfo"
        :liveStatus="liveStatus"
        :lanLabel="lanLabel"
        @showGoodsList="showGoodsList"
        @sendText="sendText"
        @showCart="showCart"
        @showShare="shareShow = true"
        :class="['room__bottom_box', {'room__bottom_box-replay' : liveStatus === 4}]">
      </room-bottom-box>
      <!-- 产品列表入口 -->
      <div class="tools__bag global_pointer" 
        :class="[{'tools__bag-replay' : liveStatus === 4}]"
        @click.stop="openGoods">
        <img class="tools__bag-logo" v-if="certificationInfo.img" :src="certificationInfo.img" />
        <div v-if="Number(goodsLength) > 0" :class="['tools__bag-badge', Number(goodsLength) > 99 ? 'big' : '']">
          {{ goodsLength }}
        </div>
      </div>
      <!-- 购物车 -->
      <img
      @click.stop="toCart"
      :src="require('@/assets/imgs/room/room_cart.png')"
      class="tools__cart global_pointer"
    />
    <!-- 分享 -->
    <img
      @click.stop="showShare"
      :src="require('@/assets/imgs/room/room_share.png')"
      class="tools__share global_pointer"
    />
      <div v-if="showSharePop" :class="['room__share_pop', {'room__share_pop-replay' : liveStatus === 4}, 'room__share_pop_animation']">
        <img :src="require('@/assets/imgs/room/pop_share.png')">
      </div>
      <goods-list 
        v-if="goodsListShow" 
        :goods="goods" 
        :liveId="liveId"
        :business="business"
        :liveStatus="liveStatus"
        class="room__goods_list"
        @checkGood="checkGood"
        @close="goodsListShow = false"
        @tapGoods="tapGoods"
        @askHost="askHost">
      </goods-list>
      <cart v-if="cartShow" @buy="checkGood" @cartBack="cartBack"/>
      <transition name="slide-fade">
        <div v-if="tipsShow" class="room__tips">
          <span>{{ $t('message.room.viewMore') }}</span>
          <img :src="require('@/assets/imgs/room/up.png')">
        </div>
      </transition>
      <share v-if="shareShow" @shareClose="shareShow = false" :shareInfo="shareInfo"></share>
		</section>
    <share-note v-if="shareShow && inviteCode && $i18n.locale === 'en'" :code="inviteCode" @shareClose="shareShow = false" class='room__share_note' />
	</div>
</template>

<script>
import ssVuePlayer from "@/components/room/ssVuePlayer";
import roomLeftTopBox from "@/components/room/roomLeftTopBox";
import roomRightTopBox from "@/components/room/roomRightTopBox";
import roomBottomBox from "@/components/room/roomBottomBox";
import quickPhrases from "@/components/room/quickPhrases";
import comment from "@/components/room/comment";
import goodsList from "@/components/shop/goodsList";
import payList from "@/components/shop/payList";
import api from "@/api/api_list.js";
import { RYun } from "@/common/rongYunSocket";
import { GetSlideDirection } from "@/utils";
import cart from "@/views/Scene/Cart";
import share from "@/components/room/share";
import { LIVESTATUS, LIVESOURCE, LIVEMSGSOURCE} from '@/assets/js/const'
import agoraPlayer from '@/components/room/agoraPlayer'
import { agoraRTC } from '@/common/agoraSocket'
import shareNote from '@/components/room/shareNote';
import shareGuide from '@/components/share/shareGuide.vue'
import { getDeviceId, plateForm, getUrlQuery } from '@/utils'
import { mapState } from "vuex"
import { Dialog } from 'vant';
import OpenApp from "@/common/openApp";
let touchStartX, touchStartY;
let showTipTimer, hidTipTimer;
export default {
	data() {
		return {
			liveId: "",
			playUrl: "",
      // 用于浏览器不支持artc格式时自动切换到hls
      playUrlStreamInfo: {
        source: null,
        streams: null,
      },
			commentMsgList: [],
			ryInstance: new RYun(),
      leftTopInfo: {},
      goods: [],
      certificationInfo: {},
      goodsLength: 0,
      liveStatus: LIVESTATUS.LIVE,
      goodsListShow: false,
      checkedGood: [],
      touchPostion: {
        startX: 0,
        startY: 0
      },
      reloadFlag: false,
      cartShow: false,
      tipsShow: false,
      business: {},
      isLive: true,
      shareShow: false,
      previewInfo: '',
      rongPlayUrl: '',
      agoraClient: null,
      playAgoraState: false,
      streamInstance: null,
      lanLabel: 1,
      shareGuideShow: false,
      shareName: '',
      bookStartTime: '',
      inviteCode: '',
      sharePrice: '',
      shareInfo: null,
      coverImg: '',
      enterTime: null,
      isIOS: plateForm().isIOS,
      addRemind: false,
      quickPhrasesData:null,
      showSharePop:false
		};
	},
  inject: ["reload"],
	components: {
		ssVuePlayer,
		roomLeftTopBox,
		roomRightTopBox,
		roomBottomBox,
		comment,
    goodsList,
		payList,
    cart,
    share,
    agoraPlayer,
    shareGuide,
    shareNote,
    [Dialog.Component.name]: Dialog.Component,
    quickPhrases
	},
	created() {
		let liveId = this.$route.params.room_id;
		this.liveId = liveId || "";
	},
	mounted() {
    this.init()
    
      setTimeout(function(){
          this.showSharePop = false
      }.bind(this),10*1000);
	},
	beforeDestroy() {
		this.ryInstance && this.ryInstance.disconnectRy()
    this.agoraClient && this.agoraClient.leave()
    this.setLeaveSa()
	},
  watch: {
    $route(to, from) {
      this.reloadFlag = false
      this.$nextTick(() => {
        let liveId = this.$route.params.room_id;
        this.liveId = liveId || "";
        this.init()
      })
    }
  },
  computed: {
    ...mapState("home", ['priceSwitchStatus']),
    roomVideoList: {
      get() {
        return this.$store.state.video.roomVideoList || [];
      },
      set(val) {
        this.$store.commit("video/concatRoomVideoList", val);
      }
    }
  },
	methods: {
    setJoinSa() {
      this.enterTime = new Date();

        // 1 -> 预告 2 -> 直播中 4 -> 回放
        let liveType = "正在直播"
        if (this.liveStatus == 1) {
          liveType = "直播预告"
        }else if(this.liveStatus == 4){
          liveType = "直播回放"
        }
      this.sa.track({
        eventId: 'joinRoom',
        eventParam: {
          liveId: this.liveId,
          liveName: this.shareInfo.liveName,
          liveType: liveType,
          liveLanguage: this.lanLabel==2? '中文': '英文',
          randomStr: getDeviceId(),
          hostID: this.leftTopInfo.hostId,
          hostNickName: this.leftTopInfo.nickname,
          cityOfStore: this.leftTopInfo.city,
          countryOfStore: this.leftTopInfo.country,
          storeName: this.shareInfo.hostName,
          storeId: this.business.id,
          storeLanguage: this.lanLabel==2? '中文': '英文',
          isFollowHost: this.leftTopInfo.isFollowed
        }
      });
    },
    setLeaveSa() {
      let duration = 0
      if (this.enterTime) {
        duration = new Date().getTime() - this.enterTime.getTime()
      }
      let liveType = "正在直播"
        if (this.liveStatus == 1) {
          liveType = "直播预告"
        }else if(this.liveStatus == 4){
          liveType = "直播回放"
        }
      this.sa.track({
        eventId: 'leaveRoom',
        eventParam: {
          liveId: this.liveId,
          liveName: this.shareInfo.liveName,
          liveType: liveType,
          liveLanguage: this.lanLabel==2? '中文': '英文',
          randomStr: getDeviceId(),
          hostID: this.leftTopInfo.hostId,
          hostNickName: this.leftTopInfo.nickname,
          storeName: this.shareInfo.hostName,
          storeId: this.business.id,
          cityOfStore: this.leftTopInfo.city,
          countryOfStore: this.leftTopInfo.country,
          storeLanguage: this.lanLabel==2? '中文': '英文',
          isFollowHost: this.leftTopInfo.isFollowed,
          duration: duration
        }
      });
    },
    init() {
      this.getRoom();
      this.getComments()
      this.getGoods()
      this.getQuickPhrases()
    },
    openGoods(){
      this.$refs.tools.openGoods();
    },
    toCart() {
      this.$refs.tools.toCart();
    },
    showShare() {
      this.$refs.tools.showShare();
    },
		async getRoom() {
			if (!this.liveId) return;
      let userInfo = this.$storage.get('user_info') || null
      if (userInfo && userInfo.inviteCode) {
        this.inviteCode = userInfo.inviteCode
      }
      this.ryInstance.initRy({
				userInfo,
				liveId: this.liveId,
				on: this.socketCallback,
			});
      // id: this.liveId,
			await api.get_live_room({
        id: this.liveId,
      }).then((res) => {
        let roomInfo = res.result
        let {
          liveStatus,
          bookStartTime = '',
          liveName,
          store,
          business,
          introduceVideo,
          livePullStreamList,
          playbackVideo,
          agoraToken,
          agoraUid,
          source,
          liveHostInfo,
          liveImg,
          lanLabel
        } = roomInfo;
        this.shareName = liveName;
        this.bookStartTime = bookStartTime;

        this.setLeftTop(roomInfo)
        this.setBottom(business, store)
        this.setBusiness(store)
         //@desc 原来开始取的store里的lanLabel这是错误的，现改成直接取直播间的lanbel
        // this.lanLabel = store.lanLabel || 1 
        this.lanLabel = lanLabel || 1; // 直播间语言 1, "英文且中文不可见" 2, "汉语" 3, "英语"

        // 1 -> 预告 2 -> 直播中 4 -> 回放
        this.liveStatus = Number.isNaN(Number(liveStatus.code)) ? LIVESTATUS.LIVE : Number(liveStatus.code)
        this.getVideos()
        

        this.shareInfo = {liveName, hostName: liveHostInfo.nameEn, previewImg:liveImg.url, liveStatus:this.liveStatus, bookStartTime}
        this.coverImg = liveImg.url

        let url = window.location.href;
        api.create_short_url({ content: url }).then((res) => {
          if (res.code === 0) {
            let shortUrl = res.result;
            this.shareInfo.shortUrl = shortUrl
          }
        });

        if (liveStatus.code == LIVESTATUS.PREVIEW) {
          // 存起来只为全局 banner 点击时知道当前直播间状态
          this.$store.commit("room/updateSchemeType", 4);
          this.isLive = false
          this.playUrl = introduceVideo.url
          this.previewInfo = this.$moment(new Date(bookStartTime)).format('MMM D, h:mmA')
        }
        if (liveStatus.code == LIVESTATUS.LIVE) {
          // 存起来只为全局 banner 点击时知道当前直播间状态
          this.$store.commit("room/updateSchemeType", 5);
          this.isLive = true
          // 保存cdn流的地址，在声网不可使用的时候使用该链接
          this.rongPlayUrl = (livePullStreamList[1] || {}).hlsUrl;

          // @todo 微信环境 不使用声网播放. 声网3.1不支持微信，默认会使用Rts，而rts已经不再维护了，遗留了各种兼容问题。
          const isWeiXin = navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') !== -1;

          // 阿里Artc流
          if( source === LIVESOURCE.ARTC ){
            this.playUrl = (livePullStreamList[1] || {}).artcUrl;

            this.playUrlStreamInfo.source = source;
            this.playUrlStreamInfo.streams = livePullStreamList[1] || null;

          }else if ( source === LIVESOURCE.AGORA && !isWeiXin ) { // 声网 且是未在微信里
            this.agoraClient = new agoraRTC()
            this.agoraClient.init({
              token: agoraToken,
              channel: this.liveId,
              uid: agoraUid - 0,
              on: this.agoraListenerEvent
            })
          } else {
            // 播放地址
            this.playUrl = (livePullStreamList[1] || {}).hlsUrl
          }
        }
        if (liveStatus.code == LIVESTATUS.VIDEO) {
          // 存起来只为全局 banner 点击时知道当前直播间状态
          this.$store.commit("room/updateSchemeType", 6);
          this.isLive = false
          this.playUrl = playbackVideo
        }
        this.$nextTick(() => {
          this.reloadFlag = true
        })
        setTimeout(() => {
          this.$refs.roombody.scrollTo(0, 10);
        },0);
      });
		},
    setLeftTop({liveHostInfo, store, liveStatus}) {
      let leftTopInfo = {}
      leftTopInfo.country = store.countryName
      leftTopInfo.city = store.cityName
      leftTopInfo.avatar = liveHostInfo.headImg.url
      leftTopInfo.nickname = liveHostInfo.userName
      leftTopInfo.isFollowed = liveHostInfo.isLiked
      leftTopInfo.hostId = liveHostInfo.id
      leftTopInfo.role = liveHostInfo.role
      leftTopInfo.storeId = store.id
      leftTopInfo.liveId = this.liveId
      leftTopInfo.liveStatus = (liveStatus || {}).code
      this.leftTopInfo = leftTopInfo
    },
    setBottom({attestation = 0, attestationStr = ''}, {logo = {}}) {
      this.certificationInfo = {attestation, attestationStr, img : logo.url || require("@/assets/imgs/logo.png")}
    },
    setBusiness({ id, nameEn, logo = {} }) {
      this.business.id = id
      this.business.name = nameEn
      this.business.logo = logo.url || require("@/assets/imgs/logo.png")
    },
    getGoods() {
      api
				.list_live_merchandise({
					liveId: this.liveId,
				})
				.then((res) => {
          // if (res.result!=null) {
          //   this.goods = res.result.reverse()
          // }
          this.goods = res.result
          this.goodsLength = res.result && res.result.length
				});
    },
    showGoodsList() {
      this.goodsListShow = true
    },
    checkGood(good) {
      this.checkedGood = good
      this.goodsListShow = false
      this.cartShow = false

      this.$order.open({checked: good, liveId: this.liveId})
    },
		getComments() {
			if (!this.liveId) return;
      api.list_msg({
					liveId: this.liveId,
					pageSize: 30,
				})
				.then((res) => {
					console.log(res);
          if (res.code === 0) {
            this.commentMsgList = res.result || [];
            // this.$refs.comment.setScroll()
          }
				});
		},
    getQuickPhrases() {
			if (this.liveStatus === 4||this.quickPhrasesData) return;
        api.get_quick_phrases()
				.then((res) => {
					console.log(res);
          if (res.code === 0) {
            this.quickPhrasesData = res.result.engVersion || [];
          }
				});
		},
    
		socketCallback(socketData) {
			console.log("socketData:", socketData);
			const type = socketData.eventName;
			const types = {
				joinRoom: ({ userInfo, roomInfo, extraData }) => {
					// console.log('joinRoom', userInfo, roomInfo, extraData);
				},
				joinBuyCart: ({ userInfo }) => {
					// this.slideBuyChange(userInfo, this.lan.toCart, 3);
				},
				readyToBuy: ({ userInfo }) => {
					// that.slideBuyChange(userInfo, this.lan.readyBuy, 1);
				},
				isBuying: ({ userInfo }) => {
					// this.slideBuyChange(userInfo, this.lan.buying, 1);
				},
				// 跑屏消息
				sendChatroomMsg: (data) => {
					this.sendPageMsg(data);
				},
				// 直播间商品删除
				mdseRemoveFromLive: ({ extraData }) => {
          console.log('mdseRemoveFromLive', extraData)
          const merchandiseId = extraData && extraData.merchandiseId
          const delIndex =
            this.goods &&
            this.goods.findIndex((item) => item.id === merchandiseId)
          this.goods.splice(delIndex, 1)
          this.goodsLength--
				},
				// 直播间商品新增
				mdsePublishInLive: ({ extraData }) => {
          console.log('mdsePublishInLive', extraData)
          extraData.id = extraData.merchandiseId
          extraData.notice = extraData.notice && JSON.parse(extraData.notice)

          // console.log('上架了新商品：：：：', JSON.stringify(extraData));

          try{
            // 隐藏上架价格
            if( this.priceSwitchStatus.showShelf === 0 ){
              delete extraData.minShelfAmountMoney
            }
            
            // 隐藏 划价
            if( this.priceSwitchStatus.showOrigin === 0 ){
              delete extraData.miniOrgAmountMoney
            }

            // 隐藏 折扣字符串 
            if( this.priceSwitchStatus.showDiscount === 0 ){
              delete extraData.userDiscountStr
            }
          }catch(e){
            console.log('移除socket数据时出错：', e);
          }
          
          this.goods.unshift(extraData)
          this.goodsLength++
				},
				// 直播间商品修改
				updateLiveMdse: ({ extraData }) => {
          // console.log('更新了商品。。。。。。。。。', extraData);
          const merchandiseId = extraData && extraData.merchandiseId
          const delIndex =
            this.goods &&
            this.goods.findIndex((item) => item.id === merchandiseId)
          extraData.id = merchandiseId
          if (Object.prototype.toString.call(extraData.notice) === '[object String]') {
            extraData.notice = extraData.notice && JSON.parse(extraData.notice)
          }
          extraData.miniAmountMoney = extraData.miniAmountUsdMoney
            ? extraData.miniAmountUsdMoney
            : extraData.miniAmountMoney
          extraData.miniOrgAmountMoney = extraData.miniOrgAmountUsdMoney
            ? extraData.miniOrgAmountUsdMoney
            : extraData.miniOrgAmountMoney

          try{
            // 隐藏上架价格
            if( this.priceSwitchStatus.showShelf === 0 ){
              delete extraData.minShelfAmountMoney
            }
            
            // 隐藏 划价
            if( this.priceSwitchStatus.showOrigin === 0 ){
              delete extraData.miniOrgAmountMoney
            }

            // 隐藏 折扣字符串 
            if( this.priceSwitchStatus.showDiscount === 0 ){
              delete extraData.userDiscountStr
            }
          }catch(e){
            console.log('移除socket数据时出错：', e);
          }

          // 显示在app
          if (delIndex > -1) {
            this.$set(this.goods, delIndex, extraData)
          } else {
            this.goods.unshift(extraData)
          }
				},
				// 直播开始
				liveStart: () => {
          console.log('liveStart')
          // this.setJoinSa()
				},
				// 直播重开
				liveRestart: () => {
          console.log('liveRestart')
				},
				// 直播结束
				liveStop: () => {
          console.log('liveStop')
				},
			};
			// 还差detail
			if (types[type] && socketData.roomInfo.roomId === this.liveId) {
				types[type](socketData);
			}
		},
    askHost(e) {
      let txtMsg = e;
      if (this.$isZh) {
        txtMsg = `${this.$t('message.goods.askHostPushPre')}${e}${this.$t('message.goods.askHostPushSub')}`
      }
      this.sendText(txtMsg, this.$t('message.goods.askHostMsg'))
    },
		sendPageMsg({ extraData, userInfo }) {
			this.commentMsgList.push({
				createTime: "",
				liveMsgSource: 6,
				msg: extraData.msg,
				uid: userInfo.uid,
				userName: userInfo.userName,
        headImg: userInfo.headImg
			});
		},
    sendText(e, cbMsg = ''){
      this.$isLogin(function () {
        this.asyncSendText(e, cbMsg)
      }.bind(this));
    },
    async asyncSendText(e, cbMsg = '') {
      await api.check_send_msg_auth({
        liveId: this.liveId
      }).then(async ({result = {}}) => {
        if (result && result.haveAuth) {
          this.ryInstance.sendText({
            eventName: 'sendChatroomMsg',
            roomInfo: { roomId: this.liveId },
            params: {
              liveStatus: this.liveStatus
            },
            extraData: {
              msg: e,
              msgType: this.liveStatus,
              liveMsgSource: 6
            },
            callback: async (sendDataMsg) => {
              await this.sendPageMsg(sendDataMsg)
              if (cbMsg) {
                this.$toast(cbMsg)
              }
              // this.changeInputState(false)
            }
          })
            // 没有权限，被禁言
        } else {
          // await this.sendPageMsg({
          //   extraData: { msg: e },
          //   userInfo: this.userInfo
          // })
          // this.changeInputState(false)
        }
      })
    },
    setNextType() {
      let currStatus = this.$store.state.video.roomStatus
      switch (currStatus) {
        case 1:
          currStatus = 4
          break;
        case 2:
          currStatus = 1
          break;
        case 4:
          currStatus = 2
          break;
        default:
          currStatus = 0
          break;
      }
      if (currStatus === 0) return
      this.$store.commit("video/updateRoomStatus", currStatus);
      this.$store.commit("video/updateRoomPageNum", 1);
      this.$store.commit("video/updateRoomIsHasNext", true);
    },
    async getVideos(){
      // 1 -> 预告 2 -> 直播中 4 -> 回放
      if (this.$store.state.home.lastId && this.roomVideoList.length === 0) {
        // 首页第一次进入
        this.$store.commit("video/updateRoomStatus", Number(this.liveStatus));
      }
      let liveStatusList = [String(this.$store.state.video.roomStatus || 2)]
      let pageNum = this.$store.state.video.roomPageNum
      let pageSize = this.$store.state.video.roomPageSize
      let curr = this.$store.state.video.roomCurrentIndex
      if (this.roomVideoList.length === 0 || curr > this.roomVideoList.length - 3) {
        api.get_home_list({
          "liveStatusList": liveStatusList,
          "pageNum": pageNum,
          "pageSize": pageSize
        }).then(res=>{
          let {data = [], pages = 1} = res.result
          if (data.length === 0) {
            this.setNextType()
            this.getVideos()
            return
          }
          data = data.map(i => i.id)
          let index = data.indexOf(this.liveId)
          if (this.roomVideoList.length === 0) {
            if (index > -1) {
              data.splice(index, 1)
            }
            data.splice(0, 0, this.liveId)
          }
          this.$store.commit("video/concatRoomVideoList", data);
          let hasNext = pageNum++ < pages
          if (!hasNext) {
            this.setNextType()
            return
          }
          this.$store.commit("video/updateRoomIsHasNext", hasNext);
          this.$store.commit("video/updateRoomPageNum", pageNum);

        })
      }
    },
    touchstartHandle(ev) {
      // if (this.roomVideoList.length === 0) return
      touchStartX = ev.touches[0].pageX;
      touchStartY = ev.touches[0].pageY;
    },
    touchendHandle(ev) {
      // if (this.roomVideoList.length === 0) return
      let endX = ev.changedTouches[0].pageX;
      let endY = ev.changedTouches[0].pageY;
      let direction = GetSlideDirection(touchStartX, touchStartY, endX, endY);
      if (![1,2].includes(direction)) return
      let curr = this.$store.state.video.roomCurrentIndex
      let redirect = ''
      switch (direction) {
        case 1:
          if (curr === this.roomVideoList.length - 1) return this.$toast(this.$t('message.room.nomore'))
          redirect = this.roomVideoList[curr + 1]
          this.$store.commit("video/changeRoomCurrentIndex", 1);
          break
        case 2:
          if (curr < 1) {
            return this.$toast(this.$t('message.room.isFirst'))
          } else {
            redirect = this.roomVideoList[curr - 1]
            this.$store.commit("video/changeRoomCurrentIndex", -1);
          }
          break
        default:
          break;
      }

      console.log(this.liveId, 'to', redirect)
      this.$router.replace({path: `/app/room/${redirect}`})
    },
    showCart() {
      this.cartShow = true
    },
    cartBack() {
      this.cartShow = false
    },
    playHandle() {
      console.log('playHandle')
      this.setJoinSa()
      this.showTip()
    },
    showTip(){
      let isSwiped = this.$store.state.room.swiped
      if (isSwiped) return
      if (this.liveStatus === 4) return
      if (!this.roomVideoList || this.roomVideoList.length < 1) return
      let curr = this.$store.state.video.roomCurrentIndex
      if (curr === this.roomVideoList.length - 1) return
      //todo
      showTipTimer = setTimeout(() => {
        this.tipsShow = true
        clearTimeout(showTipTimer)
      }, 2000);
      hidTipTimer = setTimeout(() => {
        this.hideTip()
        clearTimeout(hidTipTimer)
      }, 4000);
    },
    hideTip() {
      this.$store.commit("room/updateSwiped", true);
      this.tipsShow = false
    },
    agoraListenerEvent({ name, param } = {}) {
      console.error('name---', name)
      console.error('param---', param)
      switch (name) {
      case 'playStream': {
        this.playAgoraState = true
        this.streamInstance = param.stream
        console.log('params.stream', param.stream)
        break
      }
      case 'streamRemoved': {
        console.log('streamRemoved')
        this.reload()
        break
      }
      case 'error': {
        const errObj = param || {}
        // const code = errObj.code || 0
        // const reason = errObj.reason || ''
        console.error('=====', errObj)
        // this.textToast(`${code}:${reason}`)
        break
      }
      case 'agoraCantUse': {
        console.log('agoraCantUse')
        this.playUrl = this.rongPlayUrl
        break
      }
      }
    },
    tapGoods(goodId){

      let source = 0
      if (this.liveStatus==1) {
        source = 1
      }else if(this.liveStatus==4){
        source = 2
      }else{
        source = 0
      }

          this.$router.push({
                path: '/app/goods_detail',
                query: {
                    goodsId: goodId,
                    liveId: this.liveId,
                    source: source,
                    liveStatus: this.liveStatus,
                    liveName: this.shareInfo.liveName
                }
            });
    },
    rsvp() {
      this.remind();
      const isSafari =
        this.isIOS &&
        !/Chrome/.test(navigator.userAgent) &&
        !/CriOS/.test(navigator.userAgent) &&
        !/GSA/.test(navigator.userAgent);
      if (isSafari) {
        window.open('data:text/calendar;charset=utf8,' + escape(this.getCalenderFile()));
      }
    },
    getCalenderFile(){
      // const startDateTime = "20200403T170000";
      const startDateTime = this.$moment(new Date(this.shareInfo.bookStartTime)).format('YYYYMMDDThhmmss');
      const endDateTime = this.$moment(new Date(this.shareInfo.bookStartTime + 300000)).format('YYYYMMDDThhmmss');
      // const datetime = new Date(this.shareInfo.bookStartTime);
      // const location = '';
      // const name = this.shareInfo.liveName + ' ' +  window.location.href;
      const icsMSGArr = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Microsoft Corporation//Outlook 16.0 MIMEDIR//EN',
        'METHOD:REQUEST',
        'X-MS-OLK-FORCEINSPECTOROPEN:TRUE',
        'BEGIN:VEVENT',
        `DESCRIPTION: ${this.shareInfo.liveName}`,
        `DTSTAMP:${startDateTime}`,
        `DTSTART:${startDateTime}`,
        `DTEND:${endDateTime}`,
        `SUMMARY;LANGUAGE=en-sg:${this.shareInfo.liveName}`,
        `URL:${window.location.href}`,
        `UID:shopshop-${this.liveId}`,
        'X-MICROSOFT-CDO-BUSYSTATUS:TENTATIVE',
        'X-MICROSOFT-CDO-IMPORTANCE:1',
        'X-MICROSOFT-CDO-INTENDEDSTATUS:BUSY',
        'X-MICROSOFT-DISALLOW-COUNTER:FALSE',
        'X-MS-OLK-CONFTYPE:0',
        'BEGIN:VALARM',
        'TRIGGER:-PT5M',
        'ACTION:DISPLAY',
        'DESCRIPTION:Reminder',
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR',
      ]
      const icsMSG = icsMSGArr.join('\n');
      return icsMSG;
    },
    remind() {
      api.follow_prelive_remind_get({ liveId: this.liveId, source: '主播主页' }).then((res)=>{
        this.$shareGuide.open(null, {type: 2});
        this.addRemind = true;
      }).catch((err) => {
      });
    },
    downloadApp() {
      const jumpType = getUrlQuery("jumpType"),
      jumpId = getUrlQuery("jumpId");
      const openApp = new OpenApp();
      openApp.init({
        auto: false,
        isLink: true,
        action: {
          jumpType,
          jumpId,
        },
      });
      openApp._goUniversal();
		},
	},
};
</script>

<style lang="less" scoped>
@bottomHeight: 65px;
@bottomHeightReplay: 65px;//114.99px
@quickPhrasesHeight: 30px;
@holderZindex: 10;
@blockZindex: 20;
@keyframes pop {
  0% {opacity: 0;}
  10% {opacity: .5;}
  20% {opacity: 1;}
  100% {opacity: 1;}
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  bottom: 100px;
  opacity: 0;
}
.room {
	width: 100%;
	height: 100%;
  background: #1D1D1D;
	overflow: hidden;
	&__body {
		width: 100%;
		height: 100%;
		position: relative;
    z-index: 1;
	}
	&__player {
		width: 100%;
		height: 100%;
	}
	&__left_top {
		position: absolute;
		left: 12px;
		// top: 13px;
    text-align: left;
    z-index: @blockZindex;
	}
  &__preview {
    position: absolute;
    top: 62px;
    width: 100%;
    text-align: left;
    height: 50px;
    // background-color: rgba(47, 47, 47,0.3);
    z-index: @blockZindex;
    display: flex;
    align-items: center;
    overflow: hidden;
    &_left{
      // flex: 1;
      overflow: hidden;
      padding-left: 12px;
      padding-right: 8px;
    }
    &_right{
      width: 66px;
      height: 24px;
      background: #F2FFD3;
      color: #0D0E13;
      border-radius: 22px;
      line-height: 24px;
      display: flex;
      align-items: center;
      margin-right: 48px;
      i{
        width: 12px;
        height: 12px;
        background-image: url(../../assets/imgs/room/alarm_clock.png);
        background-size: 100%;
        margin-left: 8px;
        margin-right: 6px;
      }
      span{
        font-size: 12px;
        width: 65px;
        // color: #fff;
        color: #0D0E13;
        line-height: 22px;
        font-family: "Approach-Medium";
        border-radius: 18px;
        text-align: center;
          // width: 100%;
      }
      &.previewed{
        // background-color: rgba(255, 255, 255, 1);
        background-color: #F2FFD3;
        text-align: center;
        span{
          width: 65px;
          // width: 100%;
          border-radius: 18px;
        font-family: "Approach-Medium";
          color: rgba(0, 0, 0, 1);
        }
      }
    }
    &_livename{
      color: #fff;
      font-size: 13px;
      font-family: "TradeGothicLT-Bold";
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    p{
      color: #fff;
      font-size: 12px;
      font-family: "TradeGothicLT";
      font-weight: 200;
    }
  }
  &__top{
    &_bg{
      background-image: linear-gradient(0, rgba(29,29,29, 0) 30%, rgba(29,29,29,1) 100%);
      // background-image: linear-gradient(1, rgba(0,0,0,1), rgba(0,0,0,0));
  // background-image: linear-gradient( rgba(0,0,0,0.3), transparent);
      width: 100%;
      top: 0;
      height: 153px;
      position: absolute;
      left: 0;
      // &::after{
      //   position: absolute;
      //   content: '';
      //   width: 80%;
      //   height: 1px;
      //   background-color: rgba(255,255,255,0.1);
      //   bottom: 0;
      //   left: 0;
      //   right: 0;
      //   margin: 0 auto;
      // }
    }
  }
	&__right_top {
		position: absolute;
		right: 15px;
		top: 10px;
    width: 36px;
    height: 82px;
    z-index: @blockZindex;
	}
  &__touch_holder {
    position: absolute;
		left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: @holderZindex;
  }
  &__comment_backgroud{
    width: 100%;
    bottom: 0;
    position: absolute;
    left: 0;
    height: @bottomHeight + @quickPhrasesHeight + 165px;
    background-image: linear-gradient(0,
      rgba(0, 0, 0, 1) ,
      transparent 
    );
  }
	&__comment {
		position: absolute;
		left: 0;
		bottom: @bottomHeight + @quickPhrasesHeight;
    width: 310px;
    height: 165px;
    scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: @blockZindex;
    &::-webkit-scrollbar {
      display: none;
    }
    &-replay {
		  bottom: @bottomHeightReplay;
    }
	}
  &__quick_phrases {
		position: absolute;
		left: 0;
		bottom: @bottomHeight;
		width: 100%;
		height: @quickPhrasesHeight;
    z-index: @blockZindex;
     &-replay {
		  visibility:hidden;
    }
	}
	&__bottom_box {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: @bottomHeight;
    z-index: @blockZindex;
    &-replay {
      bottom: 50px;
    }
	}
  &__share_note {
    position: absolute;
		left: 50%;
		bottom: 140px;
    transform: translateX(-50%);
    z-index: 102;
  }
  &__share_pop {
    position: absolute;
    right: 12px;
    bottom: 60px;
    width: 112.99px;
    height: 66px;
    z-index: 20;
    opacity: 0;
    &_animation{
      animation: pop 5s ease-in-out 5s reverse;
    }
    >img {
      width: 100%;
    }
    &-replay {
      bottom: 110px;
    }
  }
  &__tips {
    height: 34px;
    box-sizing: border-box;
    padding: 0 14px;
    background: #1D1D1D;
    border-radius: 17px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #FFFFFF;
    z-index: @blockZindex;
    display: flex;
    justify-content: center;
    align-items: center;
    >span {
      line-height: 34px;
      white-space:nowrap;
      font-weight: 500;
    }
    >img {
      width: 14px;
      height: 14px;
      margin-left: 6px;
    }
  }
}
.tools{
  // position: absolute;
  &__share {
     position: absolute;
      top: 112px;
      right: 24px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      z-index: 100;
  }
  &__cart{
     position: absolute;
    top: 60px;
    right: 25px;
    width: 24px;
    height: 24px;
    z-index: 100;
  }
  &__bag {
    width: 60px;
    height: 60px;
    border: 2px solid #fff;
    border-radius: 50%;
    position: absolute;
    right: 20px;
    bottom: @bottomHeight + @quickPhrasesHeight + 20px;
    z-index: @blockZindex;
    &-replay {
      bottom: @bottomHeightReplay;
    }
    &-logo {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    &-cert {
      width: 100%;
      height: 13px;
      line-height: 13px;
      text-align: center;
      background: #39d2d6;
      border-radius: 7.5px;
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 9px;
      font-weight: 600;
      color: #ffffff;
    }
    &-badge {
      position: absolute;
      right: -8px;
      top: -4px;
      display: inline-block;
      box-sizing: border-box;
      // padding: 0 6px;
      height: 27px;
      line-height: 27px;
      min-width: 27px;
      background: #FF7233;
      border-radius: 27px;
      font-size: 12px;
      font-weight: 600;
      color: #ffffff;
      font-family: PingFangSC-Semibold;
      &.big{
        padding: 0 3px;
        right: -8px;
      }
    }
  }
}
</style>
<style lang="less">
@dialogZindex: 100;
.room__block {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: @dialogZindex;
  background: rgba(0, 0, 0, 0.5);
}
.divider {
  width: 311px;
  height: 1px;
  background: #EEEEEE;
  margin: auto;
}
.room__player{
  .prism-player {
    .prism-controlbar{
      width: 100%;
    }
    .prism-liveshift-progress,  .prism-progress {
      width: 100%;
    }
    .prism-time-display{
      width: 87%;
    }
  }
}

</style>